import type { AppUser } from './types';
import { switchView } from './navigation';

export type UiModules = {
  journey: boolean;
  examples: boolean;
};

export const DEFAULT_UI_MODULES: UiModules = {
  journey: true,
  examples: false,
};

export const GUEST_UI_MODULES: UiModules = {
  journey: true,
  examples: true,
};

export function normalizeUiModules(raw: unknown): UiModules {
  if (!raw || typeof raw !== 'object') {
    return { ...DEFAULT_UI_MODULES };
  }
  const obj = raw as Record<string, unknown>;
  // Back-compat: до миграции 049 ключи назывались trajectory/route_maps.
  const journey = obj.journey ?? obj.trajectory;
  const examples = obj.examples ?? obj.route_maps;
  return {
    journey: journey !== false,
    examples: examples === true,
  };
}

export function getUserUiModules(user: AppUser | null | undefined): UiModules {
  return normalizeUiModules(user?.ui_modules);
}

export function getEffectiveUiModules(
  user: AppUser | null | undefined,
  options?: { guest?: boolean },
): UiModules {
  if (options?.guest) {
    return { ...GUEST_UI_MODULES };
  }
  return getUserUiModules(user);
}

export function applyUiModulesNav(
  user: AppUser | null | undefined,
  options?: { guest?: boolean },
): void {
  const modules = getEffectiveUiModules(user, options);
  const navJourney = document.getElementById('nav-journey');
  const navExamples = document.getElementById('nav-examples');

  if (navJourney) {
    navJourney.classList.toggle('hidden', !modules.journey);
  }
  if (navExamples) {
    navExamples.classList.toggle('hidden', !modules.examples);
  }

  const activeView = document.querySelector('.view.active')?.id?.replace('view-', '');
  if (activeView === 'journey' && !modules.journey) {
    void switchView('conversation');
  }
  if (activeView === 'examples' && !modules.examples) {
    void switchView('conversation');
  }
}

export function fillUiModulesForm(user: AppUser | null | undefined): void {
  const modules = getUserUiModules(user);
  const trajEl = document.getElementById('ui-module-journey') as HTMLInputElement | null;
  const mapsEl = document.getElementById('ui-module-examples') as HTMLInputElement | null;
  if (trajEl) trajEl.checked = modules.journey;
  if (mapsEl) mapsEl.checked = modules.examples;
}

export function readUiModulesFromForm(): UiModules {
  const trajEl = document.getElementById('ui-module-journey') as HTMLInputElement | null;
  const mapsEl = document.getElementById('ui-module-examples') as HTMLInputElement | null;
  return {
    journey: trajEl?.checked !== false,
    examples: mapsEl?.checked === true,
  };
}
